import { useState } from 'react';
import { Colors } from 'basic-ui-lib/constants';
import { ConfigProvider, Input as InputAnt } from 'antd';
import styled from 'styled-components';

type InputLargeProps = {
  value?: string;
  onChange?: (value: string) => void;
  placeholder?: string;
  autoFocus?: boolean;
};

const InputLarge = ({ value, onChange, placeholder, autoFocus }: InputLargeProps) => {
  const [isFocused, setIsFocused] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange?.(e.target.value);
  };

  const hasValue = value && value.length > 0;

  return (
    <ConfigProvider
      theme={{
        components: {
          Input: {
            activeBorderColor: Colors.primary[6],
            hoverBorderColor: Colors.primary[6],
            colorBorder: Colors.neutral.border[2],
            fontSize: 28,
            fontFamily: 'Poppins',
            colorText: Colors.neutral.text[5],
            fontWeightStrong: 500,
            colorTextPlaceholder: Colors.neutral.text[4],
          },
        },
      }}
    >
      <InputWrapper>
        <StyledInput
          value={value}
          onChange={handleChange}
          placeholder={placeholder}
          autoFocus={autoFocus}
          variant='borderless'
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
        />
        <BorderLine $focused={hasValue || isFocused} />
      </InputWrapper>
    </ConfigProvider>
  );
};

export default InputLarge;

const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

const StyledInput = styled(InputAnt)`
  width: 100%;
  font-weight: 500;
  font-size: 28px;
  text-align: center;
  padding: 20px 16px;
  border-radius: 0;

  &::placeholder {
    text-align: center;
  }

  .ant-input {
    font-weight: 500;
    font-size: 28px;
    text-align: center;

    &::placeholder {
      text-align: center;
      color: ${Colors.neutral.text[4]};
    }
  }
`;

const BorderLine = styled.div<{ $focused?: boolean }>`
  width: 100%;
  height: 2px;
  background-color: ${({ $focused }) => ($focused ? Colors.primary[6] : Colors.neutral.border[2])};
  transition: background-color 0.2s ease;
`;
